var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-header clear-filter",attrs:{"filter-color":"green"}},[_c('parallax',{staticClass:"page-header-image",staticStyle:{"background-image":"url('img/header.jpg')"}})],1),_c('carousel-section'),_c('tabs-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }